import { render, staticRenderFns } from "./orgbehaviordata.vue?vue&type=template&id=a884e616&scoped=true&"
import script from "./orgbehaviordata.vue?vue&type=script&lang=js&"
export * from "./orgbehaviordata.vue?vue&type=script&lang=js&"
import style0 from "./orgbehaviordata.vue?vue&type=style&index=0&id=a884e616&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a884e616",
  null
  
)

export default component.exports